import type { PaginatedQuery } from "@shared/types/list";
import { DEFAULT_PAGE_SIZE } from "@shared/types/list";
import { t } from "@shared/utils/i18n";
import type { AmazonVcLogisticsMappingRow } from "./data";

/** 弹窗顶部摘要：当前 VC 物流渠道 */
export interface MappedProviderChannelInfo {
    id: string;
    channelName: string;
    platform: string;
    vcType: string;
    carrier: string;
    logisticsType: string;
}

export function toMappedProviderChannelInfo(row: AmazonVcLogisticsMappingRow): MappedProviderChannelInfo {
    return {
        id: row.id,
        channelName: row.name,
        platform: row.platform,
        vcType: row.vcTypeCode || row.vcType,
        carrier: row.carrier || row.logisticsProvider,
        logisticsType: row.logisticsTypeCode || row.logisticsType,
    };
}

export interface MappedProviderChannelQueryParam extends PaginatedQuery {
    /** VC 物流渠道 ID → 请求 vcLogisticsChannelId */
    channelId: string;
}

export const DEFAULT_MAPPED_PROVIDER_CHANNEL_QUERY: Omit<MappedProviderChannelQueryParam, "channelId"> = {
    page: 1,
    limit: DEFAULT_PAGE_SIZE,
};

/**
 * POST /manage/warehouseVcLogisticsChannel/mapping/list → data.items[]
 */
export interface MappedProviderChannelItemApi {
    /** 映射 ID（remove 入参 ids） */
    id?: number;
    mappingId?: number;
    providerChannelId?: number;
    providerCode?: string;
    /** 服务商名称 */
    providerName?: string;
    /** 渠道代码 */
    channelCode?: string;
    /** 渠道名称 */
    channelName?: string;
    channelStatus?: number;
    channelStatusLabel?: string;
    /** 添加人 */
    createdBy?: string;
    /** 添加时间 */
    createTime?: string;
}

/** 已映射服务商物流渠道行（弹窗表格） */
export interface MappedProviderChannelRow {
    /** 表格唯一行键（避免映射 id 缺失时勾选串行） */
    _rowKey: string;
    /** 移除入参：映射 ID */
    id: number;
    providerChannelId: number;
    providerCode: string;
    channelName: string;
    channelCode: string;
    /** 服务商名称 */
    providerName: string;
    channelStatus: number;
    channelStatusLabel: string;
    creatorName: string;
    createTime: string;
}

export function mapMappedProviderChannelItem(item: MappedProviderChannelItemApi, index = 0): MappedProviderChannelRow {
    const mappingId = Number(item.id ?? item.mappingId) || 0;
    const providerChannelId = Number(item.providerChannelId) || 0;
    // 优先映射 ID；缺失时用服务商渠道 ID / 下标，保证 keyField 唯一
    const _rowKey = mappingId > 0 ? `m-${mappingId}` : providerChannelId > 0 ? `p-${providerChannelId}` : `i-${index}`;
    return {
        _rowKey,
        id: mappingId,
        providerChannelId,
        providerCode: item.providerCode || "",
        channelName: item.channelName || "",
        channelCode: item.channelCode || "",
        providerName: item.providerName || "",
        channelStatus: Number(item.channelStatus) || 0,
        channelStatusLabel: item.channelStatusLabel || "",
        creatorName: item.createdBy || "",
        createTime: item.createTime || "",
    };
}

export function getMappedProviderChannelRowActions() {
    return [{ label: t("移除"), key: t("移除") }];
}
